// extracted by mini-css-extract-plugin
export default {"header":"header__Dcsdp","logoBox":"logoBox__vU4DQ","logo":"logo__mQjGt"};